// extracted by mini-css-extract-plugin
export default {"Current_ancillary":"AncillaryCurrentInfo_Current_ancillary__1vXGJ"};